'use client';

import { ReactNode, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/i18n';

interface I18nProviderProps {
  children: ReactNode;
}

/**
 * Este componente es un proveedor de contexto para la internacionalización (i18n).
 * Utiliza `I18nextProvider` de `react-i18next` para proporcionar la instancia de i18n a los componentes hijos.
 * También se encarga de cambiar el idioma de la aplicación según el idioma actual del documento HTML.
 *
 * @param {I18nProviderProps} props - Las propiedades del componente.
 *
 * @param {ReactNode} props.children - Los componentes hijos que tendrán acceso al contexto de i18n.
 *
 * @returns {JSX.Element} El proveedor de i18n que envuelve a los componentes hijos.
 */
export default function I18nProvider({ children }: I18nProviderProps) {
  useEffect(() => {
    const currentLang = document.documentElement.lang;

    if (currentLang && i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
